import { render, staticRenderFns } from "./heroFive.vue?vue&type=template&id=3b253682&"
import script from "./heroFive.vue?vue&type=script&lang=js&"
export * from "./heroFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports